import { useContext, useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { ReportDateProvider } from "../../../context/ReportDateContext";
import { Box, Grid } from "@mui/material";
import { InnerWrapper, MainContainer, TitleAndActionBox } from "../../common";
import ReportsSidebar from "./ReportsSidebar";
import SaleSummary from "./pages/SaleSummary";
import SalesByPaymentMethod from "./pages/SalesByPaymentMethod";
import TotalSalesByChannel from "./pages/TotalSalesByChannel";
import TopSellingItems from "./pages/TopSellingItems";
import LowSellingItems from "./pages/LowSellingItems";
import ProfitMargins from "./pages/ProfitMargins";
import SalesByCategory from "./pages/SalesByCategory";
import ExpenseByCategory from "./pages/ExpenseByCategory";
import TopContactsBySale from "./pages/TopContactsBySale";
import DiscountSummary from "./pages/DiscountSummary";
import TaxSummary from "./pages/TaxSummary";
import styles from "./styles.module.css";
import Cookies from "js-cookie";
import { LanguageContext } from "../../../context/LanguageContext";

const Reports = () => {
  const [I18n] = useContext(LanguageContext);
  const tempUserId = Cookies.get("tempUserId");
  const navigate = useNavigate();

  useEffect(() => {
    if (!tempUserId) return;
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/BusinessOverview", { replace: true });
    }
  }, [tempUserId, navigate]);

  if (tempUserId) return null;
  return (
  <MainContainer fluid className="quickSalePage">
    <Grid container>
      <Grid item md={12}>
        <TitleAndActionBox data={{ title: I18n.reports, id: "reports" }} />
        <InnerWrapper className={`innerWrapper newInnerWrapper ${styles.reportsInnerWrapper}`}>
          <Box className={styles.reportsLayout}>
            <ReportsSidebar />
            <Box className={styles.reportsContent}>
              <ReportDateProvider>
              <Routes>
                <Route index element={<Navigate to="SaleSummary" replace />} />
                <Route path="SaleSummary" element={<SaleSummary />} />
                <Route path="SalesByPaymentMethod" element={<SalesByPaymentMethod />} />
                <Route path="TotalSalesByChannel" element={<TotalSalesByChannel />} />
                <Route path="TopSellingItems" element={<TopSellingItems />} />
                <Route path="LowSellingItems" element={<LowSellingItems />} />
                <Route path="ProfitMargins" element={<ProfitMargins />} />
                <Route path="SalesByCategory" element={<SalesByCategory />} />
                <Route path="ExpenseByCategory" element={<ExpenseByCategory />} />
                <Route path="TopContactsBySale" element={<TopContactsBySale />} />
                <Route path="DiscountSummary" element={<DiscountSummary />} />
                <Route path="TaxSummary" element={<TaxSummary />} />
              </Routes>
              </ReportDateProvider>
            </Box>
          </Box>
        </InnerWrapper>
      </Grid>
    </Grid>
  </MainContainer>
  );
};

export default Reports;
